var map = {
	"./Alchemie.png": 6874,
	"./Auge.png": 5242,
	"./Axt.png": 8099,
	"./Baum.png": 1685,
	"./Blaues Kreuz.png": 841,
	"./Blitz.png": 5191,
	"./Blutstropfen.png": 2878,
	"./Bogen.png": 2159,
	"./Eis.png": 8659,
	"./Energie.png": 5851,
	"./Faust.png": 7027,
	"./Feuer.png": 2627,
	"./Gift.png": 2966,
	"./Hammer.png": 3294,
	"./Heilig.png": 1845,
	"./Herz.png": 1469,
	"./Holz.png": 5717,
	"./Intelligenz.png": 6251,
	"./Leer.png": 2444,
	"./Lupe.png": 448,
	"./Meditation.png": 6856,
	"./Mund.png": 4052,
	"./Psycho.png": 664,
	"./Schall.png": 6035,
	"./Schatten.png": 2746,
	"./Schiff.png": 4607,
	"./Schild.png": 3379,
	"./Schrei.png": 5790,
	"./Schwert.png": 1714,
	"./Sozial.png": 8582,
	"./Stiefel.png": 6006,
	"./Totenkopf.png": 3322,
	"./Uberleben.png": 7494,
	"./Umhang.png": 8986,
	"./Waage.png": 7575,
	"./Wagenrad.png": 2651,
	"./Wolf.png": 5120,
	"./Zauberbuch.png": 9181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3351;